/* eslint-disable import/prefer-default-export */
export function getCategoriesList(state) {
  return state.categories.list;
}
